import { render, staticRenderFns } from "./PhoneInformations.vue?vue&type=template&id=b145632c&scoped=true"
import script from "./PhoneInformations.vue?vue&type=script&lang=js"
export * from "./PhoneInformations.vue?vue&type=script&lang=js"
import style0 from "./PhoneInformations.vue?vue&type=style&index=0&id=b145632c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b145632c",
  null
  
)

export default component.exports